module.exports = __webpack_public_path__ + "static/media/YF50_1.e8ea6a68.jpg";